import { Color, Group } from '@makeswift/runtime/controls';

import { FontFamily } from '~/lib/makeswift/controls/font-tokens';
import { hsl } from '~/lib/makeswift/utils/color';

import { colors } from '../base-colors';

const colorGroup = (
  label: string,
  defaults: {
    background: string;
    backgroundHover: string;
    foreground: string;
    border: string;
    borderHover: string;
    text?: string;
    textHover?: string;
    backgroundDisabled?: string;
    borderDisabled?: string;
  },
) =>
  Group({
    label,
    preferredLayout: Group.Layout.Inline,
    props: {
      background: Color({ label: 'Background', defaultValue: defaults.background }),
      backgroundHover: Color({ label: 'Background hover', defaultValue: defaults.backgroundHover }),
      foreground: Color({ label: 'Text', defaultValue: defaults.foreground }),
      border: Color({ label: 'Border', defaultValue: defaults.border }),
      borderHover: Color({ label: 'Border hover', defaultValue: defaults.borderHover }),
      text: Color({ label: 'Color', defaultValue: defaults.text }),
      textHover: Color({ label: 'Color hover', defaultValue: defaults.textHover }),
      backgroundDisabled: Color({ label: 'Background disabled', defaultValue: defaults.backgroundDisabled }),
      borderDisabled: Color({ label: 'Border disabled', defaultValue: defaults.borderDisabled }),
    },
  });

export const button = Group({
  label: 'Button',
  preferredLayout: Group.Layout.Popover,
  props: {
    fontFamily: FontFamily({ label: 'Font', defaultValue: FontFamily.Body }),
    primary: colorGroup('Primary', {
      background: hsl(colors.primary),
      backgroundHover: hsl(colors.button.primary.backgroundHover),
      foreground: hsl(colors.button.primary.foreground),
      border: hsl(colors.primary),
      borderHover: hsl(colors.button.primary.borderHover),
      text: hsl(colors.button.primary.text),
      backgroundDisabled: hsl(colors.button.primary.backgroundDisabled),
      borderDisabled: hsl(colors.button.primary.borderDisabled),
    }),
    secondary: colorGroup('Secondary', {
      background: hsl(colors.button.secondary.background),
      backgroundHover: hsl(colors.button.secondary.backgroundHover, 0.1),
      foreground: hsl(colors.button.secondary.foreground, 0.1),
      border: hsl(colors.button.secondary.border),
      borderHover: hsl(colors.button.secondary.borderHover),
      text: hsl(colors.button.secondary.text),
      textHover: hsl(colors.button.secondary.textHover),
      backgroundDisabled: hsl(colors.button.secondary.backgroundDisabled),
      borderDisabled: hsl(colors.button.secondary.borderDisabled),
    }),
    tertiary: colorGroup('Tertiary', {
      background: hsl(colors.background.primary.default),
      backgroundHover: hsl(colors.contrast[100]),
      foreground: hsl(colors.foreground),
      border: hsl(colors.contrast[200]),
      borderHover: hsl(colors.contrast[200]),
    }),
    ghost: colorGroup('Ghost', {
      background: 'transparent',
      backgroundHover: hsl(colors.foreground, 0.05),
      foreground: hsl(colors.foreground),
      border: 'transparent',
      borderHover: 'transparent',
    }),
    focus: Color({ label: 'Focus', defaultValue: hsl(colors.primary, 0.2) }),
  },
});
